import { useRegulatorySession } from "../../providers/regulatoryProvider"
export function useWorkflowSession() {
  const { user, sessionKey } = useRegulatorySession()
  const roles = user?.Roles?.map((r) => r.Name as string) ?? []
  return {
    sessionKey,
    userUuid: user?.UUID ?? "",
    enterpriseUuid: user?.Enterprise.UUID ?? "",
    isSuperadmin: roles.includes("superadmin"),
    canVerify: roles.includes("admin") || roles.includes("superadmin"),
    inspectionHref: (id: string, norm: number) =>
      norm === 10 ? `/regulatory/sites/${id}` : `/sites/${id}`,
  }
}
